import React, { useState, ChangeEvent, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from "../../../utils/Hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { getUsers } from "../../../store/reducers/UsersSlice";
import {Option} from "../../common/form/ElogSelect";
import {getEmails} from "../../../store/reducers/EmailsSlice";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import {getDlogs} from "../../../store/reducers/DlogSlice";

const DlogSearch: React.FC = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { search } = useLocation();

    const usersState = useAppSelector((state) => state.users);

    const [fromDate, setFromDate] = useState<string>('');
    const [toDate, setToDate] = useState<string>('');

    useEffect(() => {
        dispatch(getUsers());

        const urlParams = new URLSearchParams(window.location.search);

        setFromDate(urlParams.get("fromDate") || '');
        setToDate(urlParams.get("toDate") || '');

        dispatch(getDlogs({ timeFrom: fromDate, timeTo: toDate }));

    }, []);

    const handleSearch = () => {
        const searchParams = new URLSearchParams();

        searchParams.set("fromDate", fromDate);
        searchParams.set("toDate", toDate);

        const newUrl = `/emails?${searchParams.toString()}`;
        navigate(newUrl);
    };

    return (
        <>
            <div className="filter clear" style={{ width: '99%' }}>
                <div className="content" style={{ width: '100%' }}>
                    <p>
                        <span style={{display: 'inline-flex'}}>
                        <label><strong>Periood:</strong></label>
                        <DatePicker
                            key={'from'}
                            value={fromDate}
                            onChange={(date) => setFromDate(date ? dayjs(date).format('DD.MM.YYYY') : '')}
                            dateFormat={'dd.MM.yyyy'}
                            className={'date'}
                            locale="et"
                            showYearDropdown={true}
                            showMonthDropdown={true}
                        />
                        –
                        <DatePicker
                            key={'to'}
                            value={toDate}
                            onChange={(date) => setToDate(date ? dayjs(date).format('DD.MM.YYYY') : '')}
                            dateFormat={'dd.MM.yyyy'}
                            className={'date'}
                            locale="et"
                            showYearDropdown={true}
                            showMonthDropdown={true}
                        />
                        </span>
                        &nbsp;&nbsp;&nbsp;
                    </p>
                </div>
                <p className="action">
                    <button type="submit" onClick={handleSearch}><span><strong>Otsi</strong></span></button>
                </p>
            </div>
        </>
    );
};

export default DlogSearch;